import React from 'react';
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselPrevious,
  CarouselNext,
} from "@/components/ui/carousel";
import Autoplay from "embla-carousel-autoplay";

const SubHero = () => {
  const plugin = React.useRef(
    Autoplay({ delay: 3000, stopOnInteraction: false })
  );

  const images = [
    {
      src: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=1200&q=80",
      alt: "Foundation Work",
      title: "FROM FOUNDATION"
    },
    {
      src: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1200&q=80",
      alt: "Modern Finishes",
      title: "TO FINISHES"
    },
    {
      src: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=1200&q=80",
      alt: "Construction Site",
      title: "EXPERT EXECUTION"
    },
    {
      src: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=1200&q=80",
      alt: "Interior Design",
      title: "PREMIUM INTERIORS"
    },
    {
      src: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=1200&q=80",
      alt: "Commercial Projects",
      title: "COMMERCIAL SPACES"
    },
    {
      src: "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=1200&q=80",
      alt: "Luxury Living",
      title: "LUXURY LIVING"
    }
  ];

  return (
    <section className="pt-28 pb-10 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <Carousel
          plugins={[plugin.current]}
          className="w-full"
          opts={{
            align: "start",
            loop: true,
          }}
        >
          <CarouselContent className="-ml-4">
            {images.map((img, index) => (
              <CarouselItem key={index} className="pl-4">
                <div className="relative h-[400px] rounded-2xl overflow-hidden group cursor-pointer">
                  <img
                    src={img.src}
                    alt={img.alt}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/50 transition-colors duration-300 flex items-center justify-center">
                    <h3 className="text-3xl md:text-4xl font-bold text-white uppercase tracking-wider text-center transform transition-transform duration-300 group-hover:scale-105">
                      {img.title.split(' ').map((word, i) => (
                        <span key={i} className="block">{word}</span>
                      ))}
                    </h3>
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex -left-12" />
          <CarouselNext className="hidden md:flex -right-12" />
        </Carousel>
      </div>
    </section>
  );
};

export default SubHero;